import React, { lazy } from 'react'
import {
  CBadge,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol,
  CProgress,
  CRow,
  CCallout
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import Streamgraph from '../political/canada/federal/Streamgraph'
import ScatterPlot from '../political/canada/federal/ScatterPlot'
import liberallogo from '../../assets/icons/liberal-logo.svg'

const WidgetsDropdown = lazy(() => import('../widgets/WidgetsDropdown.js'))
const WidgetsBrand = lazy(() => import('../widgets/WidgetsBrand.js'))



const Dashboard = () => {
  return (
    <>
      <WidgetsDropdown />
      <CCard>
        <CCardHeader>
          History of Canadian Elections
        </CCardHeader>
        <CCardBody>
          <Streamgraph />
        </CCardBody>
        <CCardFooter>
          <CRow className="text-center">
            <CCol md sm="12" className="mb-sm-2 mb-0">
              <div className="text-muted">Liberal</div>
              <strong>160 seats</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="danger"
                value={32.6}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0">
              <div className="text-muted">Conservative</div>
              <strong>119 seats</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="primary"
                value={33.7}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0">
              <div className="text-muted">Bloc Quebecois</div>
              <strong>32 seats</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="info"
                value={7.6}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0">
              <div className="text-muted">NDP</div>
              <strong>25 seats</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="warning"
                value={17.8}
              />
            </CCol>
            <CCol md sm="12" className="mb-sm-2 mb-0">
              <div className="text-muted">Green</div>
              <strong>2 seats</strong>
              <CProgress
                className="progress-xs mt-2"
                precision={1}
                color="success"
                value={2.3}
              />
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>

      <WidgetsBrand withCharts/>

      <CCard>
        <CCardHeader>
          Polling History
        </CCardHeader>
        <CCardBody>
          <ScatterPlot />
        </CCardBody>      
      </CCard>
    </>
  )
}

export default Dashboard
